import React from 'react';
import { Svg, Path } from "react-native-svg-web";


export const CircleAttention = ({
  className,
  color = '#333333',
  size = '24px',
  style }) => /*#__PURE__*/

React.createElement(Svg, {

  className: className,
  style: style,
  width: size,
  height: size,
  viewBox: "-2 -2 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 18C14.4179 18 18 14.4179 18 10C18 5.58211 14.4179 2 10 2C5.58211 2 2 5.58211 2 10C2 14.4179 5.58211 18 10 18ZM10 20C4.47754 20 0 15.5225 0 10C0 4.47754 4.47754 0 10 0C15.5225 0 20 4.47754 20 10C20 15.5225 15.5225 20 10 20Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 15C9 14.4477 9.44771 14 10 14C10.5523 14 11 14.4477 11 15C11 15.5523 10.5523 16 10 16C9.44771 16 9 15.5523 9 15Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 5C9 4.44772 9.44771 4 10 4C10.5523 4 11 4.44772 11 5V12C11 12.5523 10.5523 13 10 13C9.44771 13 9 12.5523 9 12V5Z",
  fill: color }));